import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router"
import { Route } from '../../interfaces/route';
import { RouteService } from '../../services/route.service';

const rail_routes: any = Array("AIR", "CHE", "CHW", "LAN", "MED", "FOX", "NOR", "PAO", "CYN", "TRE", "WAR", "WIL", "WTR", "GC");

@Component({
  selector: 'app-route-status-button',
  templateUrl: './route-status-button.component.html',
  styleUrls: ['./route-status-button.component.css']
})
export class RouteStatusButtonComponent implements OnInit {

  public selected_route: string;
  public selected_mode: string;
  public detailed_route: any = { id: '' };
  public routes: Route[] = [];
  public realtime: boolean = true;

  constructor(private routeService: RouteService, private route: ActivatedRoute) {
    this.selected_route = this.route.snapshot.paramMap.get('route');

    if (this.selected_route != "") {
      if (rail_routes.includes(this.selected_route)) {
        this.selected_mode = 'rail'
      }
    }

  }

  ngOnInit(): void {
    this.getRoutes();
    this.detailed_route.id = this.routeService.detailed.id

    if (this.selected_route != null) {
      this.detailed_route = { id: this.selected_route };
    }
    else {
      this.detailed_route.id = this.routeService.detailed.id
    }
  }

  getRoutes(): void {
    this.routeService.get()
      .subscribe(routes => {
        this.routes = routes;
        this.realtime = this.routeService.realtime;
      });
  }

}
